import React, { useState, useEffect } from 'react';
import { User, Mail, Phone, IdCard, Shield, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getStoredUser } from '../../services/authService';
import './profilecard.css';

const ProfileCard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = getStoredUser();
    setUser(userData);
  }, []);

  if (!user) {
    return (
      <div className="profile-page-loading">
        <p>Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <div className="profile-page-container">
        {/* Back Button */}
        <button className="profile-back-btn" onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
          <span>Back</span>
        </button>

        {/* Profile Header */}
        <div className="profile-page-header">
          <div className="profile-page-avatar">
            <User size={60} />
          </div>
          <h1 className="profile-page-name">{user.name}</h1>
          <p className="profile-page-role">
            <Shield size={16} />
            {user.role?.name || 'User'}
          </p>
        </div>

        {/* Profile Information */}
        <div className="profile-page-body">
          <h2 className="profile-section-title">Personal Information</h2>

          <div className="profile-info-grid">
            <div className="profile-info-card">
              <div className="profile-info-icon">
                <User size={24} />
              </div>
              <div className="profile-info-content">
                <span className="profile-info-label">Username</span>
                <span className="profile-info-value">{user.username}</span>
              </div>
            </div>

            <div className="profile-info-card">
              <div className="profile-info-icon">
                <Mail size={24} />
              </div>
              <div className="profile-info-content">
                <span className="profile-info-label">Email</span>
                <span className="profile-info-value">{user.email}</span>
              </div>
            </div>

            <div className="profile-info-card">
              <div className="profile-info-icon">
                <Phone size={24} />
              </div>
              <div className="profile-info-content">
                <span className="profile-info-label">Mobile</span>
                <span className="profile-info-value">{user.mobile}</span>
              </div>
            </div>

            <div className="profile-info-card">
              <div className="profile-info-icon">
                <Shield size={24} />
              </div>
              <div className="profile-info-content">
                <span className="profile-info-label">Role</span>
                <span className="profile-info-value">{user.role?.name || 'N/A'}</span>
              </div>
            </div>

            {/* <div className="profile-info-card profile-info-card-full">
              <div className="profile-info-icon">
                <IdCard size={24} />
              </div>
              <div className="profile-info-content">
                <span className="profile-info-label">Role ID</span>
                <span className="profile-info-value profile-info-id">{user.role?._id || 'N/A'}</span>
              </div>
            </div>

            <div className="profile-info-card profile-info-card-full">
              <div className="profile-info-icon">
                <IdCard size={24} />
              </div>
              <div className="profile-info-content">
                <span className="profile-info-label">User ID</span>
                <span className="profile-info-value profile-info-id">{user._id}</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
